export const ItemTypes = {
  ROW: 'row',
  COLUMN: 'column',
  ADDON: 'addon',
  INNERROW: 'innerRow',
  INNERCOLUMN: 'innerColumn',
  INNERADDON: 'innerAddon',
  BLOCK: 'block',
  BUILDERADDON: 'builderaddon',
};



// WEBPACK FOOTER //
// ./src/components/Constants.js